import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TextHidingDirective} from './text-hiding.directive';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        TextHidingDirective
    ],
    exports: [
        TextHidingDirective
    ]
})
export class TextHidingModule {}
